"use strict";
/**
 * A v4 UUID in any context. crypto.randomUUID exists only on secure origins; the recorder's local
 * rehearsal serves the pad over plain http (RECORDER-RUNBOOK §1), where getRandomValues still
 * works.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.uuidV4 = uuidV4;
exports.uuid = uuid;
function uuidV4(c = globalThis.crypto) {
    if (typeof c.randomUUID === "function")
        return c.randomUUID();
    const b = c.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40; // version 4
    b[8] = (b[8] & 0x3f) | 0x80; // RFC 4122 variant
    const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
/** The pads' idempotency ids: v4 from whatever the context offers, never throwing (an insecure context's randomUUID can). */
function uuid() {
    try {
        return uuidV4();
    }
    catch {
        return uuidV4({ getRandomValues: (a) => { const b = new Uint8Array(a.buffer); for (let i = 0; i < b.length; i++)
                b[i] = Math.floor(Math.random() * 256); return a; } });
    }
}
